import { useTranslation } from 'react-i18next';

export default () => {
  const { i18n } = useTranslation();
  return i18n.language || localStorage.getItem('i18nextLng') || 'et';
};
